import React from 'react';
import { FunctionFactory } from 'survey-core';
import { TimeAvailable } from '../quiz/timeAvailable';

const timeAvailableSplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">‍🤸‍♂️️</div>
  <div class="splash-header">
    <h1>Smart training is flexible.</h1>
    <div class="quote">
      We’ll help you make your time count. What matters most is showing up, and sticking with it.
    </div>
  </div>
</div>`;

const timeAvailableSplashExpression = {
  name: "timeAvailableQuote",
  expression: "renderTimeAvailableQuote({timeAvailable})",
};

function renderTimeAvailableQuote(params: any[]): string {
  if (params === undefined || params === null) return "";
  switch (String(params[0]) as TimeAvailable) {
    case TimeAvailable.SixtyMinutes:
    case TimeAvailable.NinetyMinutes: {
      return `Awesome! That's more than enough time. If you're ever short on time, we'll also give you "time-saving workouts" that'll get you the same gains in far less time (30 minutes or less).`;
    }
    case TimeAvailable.ThirtyMinutes:
    case TimeAvailable.FourtyFiveMinutes:
    default: {
      return `No problem! We use science to make shorter workouts (some as quick as 15 minutes) just as effective as longer ones.`;
    }
  }
}

FunctionFactory.Instance.register("renderTimeAvailableQuote", renderTimeAvailableQuote);

const timeAvailableSplashElement = {
  name: 'time-available-splash',
  type: 'html',
  html: timeAvailableSplashHtml,
};

const TimeAvailableSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px",
    }}>
      ⚙️ Factoring in your preferences
    </div>
  )
}

export {
  timeAvailableSplashElement,
  timeAvailableSplashExpression,
  TimeAvailableSplashHeader,
}
